import { signOut } from '@/store/auth/actions';
import type { UseProfileButtonReturn } from '../ProfileButton.types';
import { useAppDispatch } from '@/hooks/useAppDispatch';

export const useProfileButton = (): UseProfileButtonReturn => {
  const dispatch = useAppDispatch();

  const handleSignOut = (): void => {
    dispatch(signOut());
  };

  return { handleSignOut };
};
